<template>
  <div class="banner-block">
    <!--type submit_thesis-论文润色/翻译需求  postgraduate_guidance-考研辅导需求-->
    <div class="banner" v-if="type == 'submit_thesis'">
      <div class="container-block">
        <div class="info">
          <h1>论文润色服务</h1>
          <p>提供专业的论文润色服务，让原创论文更加出彩！</p>
          <p>INSIDER OF SCIENCE</p>
          <p>丰富的服务内容，新颖的服务方式，</p>
          <p>专业的服务团队，优惠的服务价格。</p>
        </div>
        <div class="order">
          <img src="@/assets/imgs/icon2.png" />
          <p>订单累计：{{total}}</p>
        </div>
      </div>
    </div>

    <div class="banner" v-else-if="type == 'postgraduate_guidance'">
      <div class="container-block">
        <div class="info">
          <h1>圈内人一对一考研辅导</h1>
          <p>考研这件事儿，你最需要的是圈内人的帮助！</p>
          <p>让优秀的学长学姐带你考研上岸，圆梦名校！</p>
          <p>快来！你的辅导老师就是你明年的师兄师姐！</p>
        </div>
        <div class="order">
          <img src="@/assets/imgs/icon2.png" />
          <p>订单累计：{{total}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    type: {
      // type submit_thesis-论文润色/翻译需求  postgraduate_guidance-考研辅导需求
      type: String,
      default: 'submit_thesis',
    },
    total: {
      // 订单总量
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
    }
  },
  created() {},
  methods: {},
}
</script>
<style lang="scss" scoped>
.banner-block {
  .banner {
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('../../assets/imgs/banner1.png');
    height: 336px;
    color: #ffffff;

    p {
      font-size: 18px;
    }

    .container-block {
      height: 336px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .info {
      color: #ffffff;
      margin-left: 60px;

      h1 {
        font-size: 38px;
      }
    }

    .order {
      margin-right: 220px;
    }
  }

  .banner-news {
    background-image: url('../../assets/imgs/banner3.png');
    height: 430px;
  }
}
</style>